<template>
    <div class="category-cards-skeleton">
        <!-- Loading state for category cards -->
        <div class="skeleton-scroll-arrow left"></div>
        
        <div class="skeleton-card-list">
            <div 
                v-for="n in cardCount" 
                :key="'skeleton-card-' + n"
                class="skeleton-card-item"
            >
                <div class="skeleton-card-image"></div>
                <div class="skeleton-card-title"></div>
            </div>
        </div>
        
        <div class="skeleton-scroll-arrow right"></div>
    </div>
</template>

<script>
export default {
    name: 'category-cards-skeleton',
    props: {
        cardCount: {
            type: Number,
            default: 6
        }
    }
}
</script>

<style lang="scss" scoped>
.category-cards-skeleton {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px 0;
    min-height: 140px; /* Match real category cards height */
    box-sizing: border-box;

    %skeleton-base {
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: skeleton-loading 1.5s infinite;
        border-radius: 4px;
        box-sizing: border-box;
        flex-shrink: 0;
    }

    @keyframes skeleton-loading {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }

    .skeleton-scroll-arrow {
        @extend %skeleton-base;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        flex-shrink: 0;
        
        &.left {
            order: 1;
        }
        
        &.right {
            order: 3;
        }
    }

    .skeleton-card-list {
        display: flex;
        gap: 16px;
        overflow: hidden;
        flex: 1;
        order: 2;
        min-height: 128px; /* 100px image + 12px margin + 16px title */

        .skeleton-card-item {
            flex-shrink: 0;
            width: 156px;
            text-align: center;
            min-width: 156px;

            .skeleton-card-image {
                @extend %skeleton-base;
                width: 156px;
                height: 100px;
                margin-bottom: 12px;
                border-radius: 8px;
                min-width: 156px;
                min-height: 100px;
            }

            .skeleton-card-title {
                @extend %skeleton-base;
                height: 16px;
                width: 80%;
                margin: 0 auto;
                min-height: 16px;
            }
        }
    }

    // Responsive adjustments
    @media (max-width: 768px) {
        .skeleton-card-list {
            gap: 12px;
            
            .skeleton-card-item {
                width: 120px;
                
                .skeleton-card-image {
                    width: 120px;
                    height: 80px;
                }
            }
        }
        
        .skeleton-scroll-arrow {
            width: 28px;
            height: 28px;
        }
    }
}
</style>